/**
 * Calculators stub. v1 links out to existing TakeHome calculators (the heavy
 * work lives there). Once we know which ones convert, port them in directly.
 */
export default function Calculators() {
  return (
    <section className="space-y-8">
      <header>
        <h1 className="text-3xl font-semibold">Calculators</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Quick what-if tools that use your connected data when you're logged in.
          v1 sends you to the standalone TakeHome calculators; deeper versions
          come once we know which ones matter.
        </p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2">
        <CalcCard
          name="Take-home pay"
          description="Forecast your real take-home across salary + dividends. Multi-jurisdiction (UK / US / Portugal)."
          href="https://takehome.ai/calculator"
        />
        <CalcCard
          name="Dividend strategy"
          description="Optimal salary/dividend split for your director payroll given the current tax bands."
          href="https://takehome.ai/calculator"
        />
        <CalcCard
          name="IR35 check"
          description="Quick check on whether a contract is likely to fall inside or outside IR35."
          href="https://takehome.ai/calculator"
          comingSoon
        />
        <CalcCard
          name="Pension headroom"
          description="How much of your annual allowance is left across employer + personal contributions."
          href="https://takehome.ai/calculator"
          comingSoon
        />
      </div>
    </section>
  );
}

function CalcCard({
  name,
  description,
  href,
  comingSoon,
}: {
  name: string;
  description: string;
  href: string;
  comingSoon?: boolean;
}) {
  return (
    <article className="flex h-full flex-col rounded-lg border p-5">
      <div className="flex items-start justify-between gap-3">
        <h2 className="text-lg font-semibold">{name}</h2>
        {comingSoon ? (
          <span className="rounded-full border px-2 py-0.5 text-xs text-muted-foreground">
            Coming soon
          </span>
        ) : null}
      </div>
      <p className="mt-2 text-sm text-muted-foreground">{description}</p>
      {!comingSoon ? (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className="mt-4 inline-flex items-center justify-center rounded-md border px-3 py-2 text-sm font-medium hover:bg-secondary"
        >
          Open calculator →
        </a>
      ) : null}
    </article>
  );
}
